import { get, post } from '../../apiClient';
import { API_ENDPOINTS } from '../../config';

const metaService = {
    /**
     * Get Meta (Facebook/Instagram) OAuth authorization URL
     */
    getAuthorizationUrl: async () => {
        try {
            const response = await get(API_ENDPOINTS.CRM.META.AUTHORIZE);

            if (response && response.responseCode === 200) {
                return {
                    success: true,
                    authorizationUrl: response.data.authorizationUrl
                };
            } else {
                return {
                    success: false,
                    error: response.responseMessage || 'Failed to get authorization URL'
                };
            }
        } catch (error) {
            
            return {
                success: false,
                error: error.message || 'Failed to get authorization URL'
            };
        }
    },

    /**
     * Sync Meta leads (starts background job, returns immediately)
     */
    syncLeads: async () => {
        try {
            const response = await post(API_ENDPOINTS.CRM.META.SYNC);
            // 202 = Accepted (background job started), 200 = immediate result
            if (response && (response.responseCode === 202 || response.responseCode === 200)) {
                return { success: true, message: response.responseMessage };
            } else {
                return {
                    success: false,
                    status: response?.responseCode,
                    error: response?.responseMessage || 'Failed to start sync'
                };
            }
        } catch (error) {
            const status = error.response?.status || error.response?.data?.responseCode;
            return {
                success: false,
                status,
                error: error.response?.data?.responseMessage || error.message || 'Failed to sync Meta leads'
            };
        }
    },

    /**
     * Poll sync status (call after syncLeads to track progress)
     */
    getSyncStatus: async () => {
        try {
            const response = await get(API_ENDPOINTS.CRM.META.SYNC_STATUS);
            if (response && response.responseCode === 200) {
                return { success: true, ...response.data };
            }
            return { success: false };
        } catch (error) {
            return { success: false };
        }
    },

    /**
     * Get Meta integration status
     */
    getIntegrationStatus: async () => {
        try {
            const response = await get(API_ENDPOINTS.CRM.META.STATUS);

            if (response && response.responseCode === 200) {
                return {
                    success: true,
                    ...response.data
                };
            } else {
                return {
                    success: false,
                    error: response.responseMessage || 'Failed to get integration status'
                };
            }
        } catch (error) {
            
            return {
                success: false,
                error: error.message || 'Failed to get integration status'
            };
        }
    },

    /**
     * Disconnect Meta integration
     */
    disconnect: async () => {
        try {
            const response = await post(API_ENDPOINTS.CRM.META.DISCONNECT);

            if (response && response.responseCode === 200) {
                return {
                    success: true,
                    message: response.responseMessage || 'Meta disconnected successfully'
                };
            } else {
                return {
                    success: false,
                    error: response.responseMessage || 'Failed to disconnect Meta'
                };
            }
        } catch (error) {
            
            return {
                success: false,
                error: error.message || 'Failed to disconnect Meta'
            };
        }
    }
};

export default metaService;
